import { render, staticRenderFns } from "./PageHeadAvatarNew.vue?vue&type=template&id=069d20b0&scoped=true"
import script from "./PageHeadAvatarNew.vue?vue&type=script&lang=ts"
export * from "./PageHeadAvatarNew.vue?vue&type=script&lang=ts"
import style0 from "./PageHeadAvatarNew.vue?vue&type=style&index=0&id=069d20b0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069d20b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('069d20b0')) {
      api.createRecord('069d20b0', component.options)
    } else {
      api.reload('069d20b0', component.options)
    }
    module.hot.accept("./PageHeadAvatarNew.vue?vue&type=template&id=069d20b0&scoped=true", function () {
      api.rerender('069d20b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/PageHeadAvatarNew.vue"
export default component.exports